import { types } from 'mobx-state-tree';

export const EducationModel = types.model('EducationModel', {
  id: types.maybe(types.number),
  degree: types.maybeNull(types.string),
  description: types.maybeNull(types.string),
  location: types.maybeNull(types.string),
  major: types.maybeNull(types.string),
  start: types.maybeNull(types.string),
  grade: types.maybeNull(types.string),
  university: types.maybeNull(types.string)
});
